// extracted by mini-css-extract-plugin
export default {"logoClosed":"home_logoClosed__yWutA","logoOpened":"home_logoOpened__qv2nM","img":"home_img__+n5mn","userMenu":"home_userMenu__ijY1M"};